// Theme JavaScript for enhanced functionality

document.addEventListener('DOMContentLoaded', function () {

  // Header scroll effects
  const header = document.querySelector('.header-wrapper');
  let lastScrollY = window.scrollY;

  function updateHeader() {
    const currentScrollY = window.scrollY;

    if (header) {
      if (currentScrollY > 100) {
        header.classList.add('header-scrolled');
      } else {
        header.classList.remove('header-scrolled');
      }

      // Hide header on scroll down, show on scroll up
      if (currentScrollY > lastScrollY && currentScrollY > 200) {
        header.style.transform = 'translateY(-100%)';
      } else {
        header.style.transform = 'translateY(0)';
      }
    }

    lastScrollY = currentScrollY;
  }

  // Throttled scroll handler
  let ticking = false;
  function handleScroll() {
    if (!ticking) {
      requestAnimationFrame(function () {
        updateHeader();
        ticking = false;
      });
      ticking = true;
    }
  }

  window.addEventListener('scroll', handleScroll);

  // Smooth scroll for anchor links
  const anchorLinks = document.querySelectorAll('a[href^="#"]');
  anchorLinks.forEach(link => {
    link.addEventListener('click', function (e) {
      const href = this.getAttribute('href');
      if (href === '#') return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();
        const headerHeight = header ? header.offsetHeight : 0;
        const targetPosition = target.offsetTop - headerHeight - 20;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });

  // Image lazy loading enhancement
  const images = document.querySelectorAll('img[loading="lazy"]');
  if ('IntersectionObserver' in window) {
    const imageObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const img = entry.target;
          img.classList.add('loaded');
          observer.unobserve(img);
        }
      });
    });

    images.forEach(img => imageObserver.observe(img));
  }

  // Product card hover effects
  const productCards = document.querySelectorAll('.product-card, .showcase-product, .brand-product-item');
  productCards.forEach(card => {
    card.addEventListener('mouseenter', function () {
      this.style.transform = 'translateY(-8px)';
    });

    card.addEventListener('mouseleave', function () {
      this.style.transform = 'translateY(0)';
    });
  });

  // Newsletter form enhancement
  const newsletterForms = document.querySelectorAll('.footer__newsletter-form');
  newsletterForms.forEach(form => {
    form.addEventListener('submit', function (e) {
      const email = this.querySelector('input[type="email"]').value;
      if (!isValidEmail(email)) {
        e.preventDefault();
        showNotification('Please enter a valid email address.', 'error');
        return;
      }

      // Add loading state
      const button = this.querySelector('button');
      const originalText = button.textContent;
      button.textContent = 'Loading....';
      button.disabled = true;

      // Reset after form submission (you can customize this based on your needs)
      setTimeout(() => {
        button.textContent = originalText;
        button.disabled = false;
        showNotification('Thanks for your inscription!', 'success');
      }, 2000);
    });
  });

  // Utility functions
  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  function showNotification(message, type = 'info') {
    // Create notification element
    const notification = document.createElement('div');
    notification.className = `notification notification--${type}`;
    notification.textContent = message;

    // Style the notification
    Object.assign(notification.style, {
      position: 'fixed',
      top: '20px',
      right: '20px',
      padding: '15px 20px',
      backgroundColor: type === 'error' ? '#e74c3c' : type === 'success' ? '#27ae60' : '#3498db',
      color: 'white',
      borderRadius: '4px',
      zIndex: '9999',
      transform: 'translateX(100%)',
      transition: 'transform 0.3s ease'
    });

    document.body.appendChild(notification);

    // Animate in
    setTimeout(() => {
      notification.style.transform = 'translateX(0)';
    }, 100);

    // Remove after 4 seconds
    setTimeout(() => {
      notification.style.transform = 'translateX(100%)';
      setTimeout(() => {
        if (notification.parentNode) {
          notification.parentNode.removeChild(notification);
        }
      }, 300);
    }, 4000);
  }

  // Performance optimization: Preload critical images
  function preloadImage(src) {
    const img = new Image();
    img.src = src;
  }

  // Preload hero images if they exist
  const heroSlides = document.querySelectorAll('.hero-slide');
  heroSlides.forEach(slide => {
    const bgImage = slide.style.backgroundImage;
    if (bgImage) {
      const imageUrl = bgImage.slice(4, -1).replace(/"/g, "");
      preloadImage(imageUrl);
    }
  });

  // Add loading class to body when page loads
  document.body.classList.add('loaded');

  // Handle resize events
  let resizeTimer;
  window.addEventListener('resize', function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      // Recalculate any layout-dependent elements
      updateHeader();
    }, 250);
  });

});

// CSS for loaded images and notifications
const style = document.createElement('style');
style.textContent = `
  img.loaded {
    opacity: 1;
    transition: opacity 0.3s ease;
  }
  
  img[loading="lazy"] {
    opacity: 0;
  }
  
  .loaded img[loading="lazy"] {
    opacity: 1;
  }
  
  .notification {
    font-family: var(--font-primary--family);
    font-size: 0.9rem;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
  }
`;
document.head.appendChild(style);